module.exports = function (angular, app) {
    var GroupByType = require('../columns').GroupByType;

    function deepQueryGroup($filter, DeepQueryDimensions) {
        return {
            restrict: 'E',
            scope: {
                columns: '=bindGroup',
                source: '='
            },
            templateUrl: '/tpl/deep-query/group.html',
            link: function link(scope, element, attrs) {
                scope.groupByType = GroupByType;

                function makeColumn() {
                    var column = angular.copy(GroupByType.template);
                    column.name = "";
                    return column;
                }

                scope.addGroup = function () {
                    var children = scope.columns;
                    var column = makeColumn();
                    children.push(column);
                };

                function filterIndex(column, children) {
                    for (var i = children.length; i-- > 0;)
                        if (children[i] === column)
                            return i;
                }

                scope.removeGroup = function removeGroup(column) {
                    var children = scope.columns;
                    var index = filterIndex(column, children);
                    if (index != null)
                        children.splice(index, 1);
                };

                scope.taDimensions = function taDimensions(viewValue) { // TODO: export to separate directive
                    return DeepQueryDimensions.getNamesFiltered(scope.source, viewValue, 3);
                };
            }
        };
    }

    app.directive('deepQueryGroup', ['$filter', 'DeepQueryDimensions', deepQueryGroup]);
};
